import {
  FETCH_ALTERNATIVES_REQUEST,
  FETCH_ALTERNATIVES_SUCCESS,
  FETCH_ALTERNATIVES_FAILURE,
  UPDATE_ALTERNATIVES
} from '../../actionTypes/alternativesActionTypes'

const initialState = {
  data: {},
  meta: {}
}

const buildRequestState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {})
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail: '',
        requestDone: false
      }
    }
  }
  return newState
}

const buildSuccessState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber, data: payloadData = {}, meta: payloadMeta = {} } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        products: [...payloadData]
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        ...payloadMeta,
        errorDetail: '',
        requestDone: true
      }
    }
  }
  return newState
}

const buildFailureState = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber, errorDetail } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {})
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        errorDetail,
        requestDone: true
      }
    }
  }
  return newState
}

const updateAlternatives = (oldState, payload) => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const { partNumber, data: payloadData = {} } = payload
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      [partNumber]: {
        ...(oldData[partNumber] || {}),
        ...payloadData
      }
    },
    meta: {
      ...oldMeta,
      [partNumber]: {
        ...oldMeta[partNumber],
        requestDone: true
      }
    }
  }
  return newState
}

const alternativesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ALTERNATIVES_REQUEST:
      return buildRequestState(state, payload)
    case FETCH_ALTERNATIVES_SUCCESS:
      return buildSuccessState(state, payload)
    case FETCH_ALTERNATIVES_FAILURE:
      return buildFailureState(state, payload)
    case UPDATE_ALTERNATIVES:
      return updateAlternatives(state, payload)
    default:
      return state
  }
}

export { initialState, alternativesReducer }
